document.addEventListener('DOMContentLoaded', function () {
   function tabControl(container) {
      var tabs = container?.querySelector('.tabs'),
         items = container?.querySelectorAll('.item');

      tabs?.querySelectorAll('a').forEach(function (tab) {
         tab.addEventListener('click', function (event) {
            event.preventDefault();
            var target = this.getAttribute('href').substring(1);
           
            if (!document.getElementById(target).classList.contains('active')) {
               tabs.querySelectorAll('a').forEach(function (link) {
                  link.classList.remove('active');
               });
               items.forEach(function (item) {
                  item.classList.remove('active');
               });
               this.classList.add('active');
               document.getElementById(target).classList.add('active');
            }
           });
      });
     

      items?.forEach(function (item) {
         item.addEventListener('click', function () {

           if(window.innerWidth < 800){
            var currId = this.getAttribute('id');

            if (!this.classList.contains('active')) {
               items.forEach(function (it) {
                  it.classList.remove('active');
               });
               this.classList.add('active');
               tabs.querySelectorAll('a').forEach(function (link) {
                  link.classList.remove('active');
               });
               tabs.querySelector('a[href="#' + currId + '"]').classList.add('active');
            } else {
               this.classList.remove('active');
            }
            var scrollDiv = document.getElementById(currId).offsetTop;
            window.scrollTo({
               top: scrollDiv - 61,
               behavior: 'smooth'
            });
             
           }

         });
      });
   }

   tabControl(document.querySelector('.tabbed-content'));
   tabControl(document.querySelector('.tabbed-content-two'));
});